import styled from 'styled-components';

export const CreateEmployeeWrapper = styled.div`
  .ant-form {
    margin-top: 20px;
  }
  .ant-form-item {
    width: 288px;
  }
`;
